export default function ({commit, dispatch, getters}) {
  commit('loading', true);
  dispatch('list/get', {
    data: getters['form/data'],
    cb: (data) => {
      commit('loading', false);
      commit('balance/set', data);
      commit('xls/set', {data, form: getters['form/data_report']});
    }
  })
}